import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';

import { TitleWMutedRow } from '../../../sitel/demon/ui/atoms';
import { FieldValidationErrorMsg, HelpText } from '../../../sitel/demon/ui/atoms/form';

import schema from "./formSchema";
import useFormSubmit from "./useFormSubmit";
import { useOutletContext, useLocation } from "react-router";
import PassCodeInputField from "./passCodeInputField";
import SubmitButton from "../../../sitel/demon/ui/atoms/buttons/SubmitButton";

export default function Step3EnterCodePage() {
    const { register, handleSubmit, setValue, clearErrors, formState: { errors, isSubmitting, isSubmitSuccessful } } = useForm({ resolver: yupResolver(schema()) });
    const onSubmit = useFormSubmit();
    const { language } = useOutletContext();

    const location = useLocation();
    const emailAddress = location.state.email;   // Extract the email address from the location state object

    return (
        <>
            <TitleWMutedRow muted={language.mutedTitle}>{language.title}</TitleWMutedRow>
            <p className="mb-4">
                <span>A verification code was sent to </span><span className="fw-bold">{emailAddress}</span>.
            </p>
            <h5 className="mb-2">Confirm your identity</h5>
            <HelpText>Enter the code you received in your email to finish signing in. Alternatively, you can press the link you recieved in the email to continue. This code is valid for only 30 minutes.</HelpText>
            <p className="text-center mt-4">Enter verification code</p>
            <PassCodeInputField setValue={setValue} clearErrors={clearErrors} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group text-center">
                    <div className="input-group mb-2">
                        <input type="hidden" className="form-control" id="code" placeholder="Enter verification code" {...register("code")} />
                    </div>
                    <FieldValidationErrorMsg field="code" errors={errors} />
                </div>

                <div className="row">
                    <div className="col-sm-12 px-5 my-3 text-center">
                        <SubmitButton isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful} defaultLabel="Verify Code" className="btn-medstar-primary"/>
                    </div>
                    <div className="col-sm-12 px-5 mb-3 text-center">
                        <Button className="btn-medstar-outline w-100" >Resend Code</Button>
                    </div>
                </div>
            </form>
        </>

    );;
}
